import { inject, Injectable } from '@angular/core';
import { MockService } from '@mock/mock.service';
import { delay, Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { convertStringInToSumOfAllCharacters } from '@app/shared/utils/string';
import {
  ISpreadDateChartData,
  ISpreadDateChartDataQueryParams,
  ISpreadDateChartDataRange,
  ISpreadDateChartDataValue,
} from '@app/api/interfaces/chart-data/date-spread';
import { LoggerDeploymentsDataMockService } from '@mock/data-services/logger-deployments-data-mock.service';
import { ILoggerDeploymentData } from '@app/api/interfaces/logger-deployment-data.interface';
import { generateDateDateChartData, sortByDate } from '@mock/utils/date-chart-data';

@Injectable({ providedIn: 'root' })
export class LoggerDeploymentDateSpreadMockService extends MockService {
  private loggerDeploymentsDataMockService = inject(LoggerDeploymentsDataMockService);

  public get(
    projectId: string,
    deploymentId: string,
    filter: ISpreadDateChartDataQueryParams
  ): Observable<IApiResponse<ISpreadDateChartData, object>> {
    const deployment = this.loggerDeploymentsDataMockService.loggerDeploymentsData.find(
      el => el.deploymentId === deploymentId
    );

    const dataAll: ISpreadDateChartData = deployment ? this.generateAccordingToDeployment(deployment) : { ranges: [] };

    const data = sortByDate<ISpreadDateChartDataValue, ISpreadDateChartDataRange>(dataAll, filter);

    return this.mockResponse<IApiResponse<ISpreadDateChartData, object>>(
      'LOGGER_DEPLOYMENT_DATE-SPREAD:get',
      {
        data,
        meta: {},
      },
      arguments
    ).pipe(delay(this.requestDelay));
  }

  private generateAccordingToDeployment(deployment: ILoggerDeploymentData): ISpreadDateChartData {
    return generateDateDateChartData<ISpreadDateChartDataValue, ISpreadDateChartDataRange>(
      new Date().toISOString(),
      () => ({
        deploymentId: deployment.deploymentId,
        serialNo: deployment.serialNo,
        // this will be replaced!!!!
        collected: '',
        deployed: '',
      }),
      (date: string) => {
        const spread = convertStringInToSumOfAllCharacters(date + deployment.deploymentId + 'spread') % 60;

        return {
          date,
          spread,
        };
      },
      [7, 11]
    );
  }
}
